import { useStateManager } from "@bcm-dev/bcms-vite";
import React from "react";
import "./styles.css";
import "./mobile.css";


/**
 * @function EdeEmailPage
 * @return {React.Component}
 * @exported true
 * @description The main component for the tab content "EdeEmailPage".
 * @example
 * <EdeEmailPage />
 */
export default function EdeEmailPage(props) {
    const { data, ui } = useStateManager();

    return (
    <div className="ede-email-page">
        <p className="description description-main">Notifications of eStatement availability will be sent to the email address listed below.
        To update this email address, use the Online Banking Options.
        </p>
        <p className="description email-label">Current Email Address:</p>
        <p className="description email-value-container">
            <b>{ data.contactInfo.value }</b>
        </p>
    </div>
    );
}